<template>
    <!-- DESC: 个人信息 -->
    <div class="my-container">
        <el-row justify="center" style="margin-top:25px">
            <el-col :span="24">
                <el-card class="box-card" shadow="always" body-style="padding:60px 50px;height:650px">
                    <template #header>
                        <div class="card-header">
                            <div>
                                <span>Personal Information</span>
                            </div>
                            <el-switch v-model="isChange" active-text="Modify" inactive-text="Look" inline-prompt />
                        </div>
                    </template>
                    <div>
                        <div class="picbox">
                            <el-upload class="avatar-uploader" :headers="{ 'token': token }"
                                action="https://www.gdstinfo.cn/api/user/uphpic" :show-file-list="false"
                                :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled="!isChange">
                                <div>
                                    <el-avatar :size="50" :src="myform.pic" class="mypic" />
                                </div>
                            </el-upload>
                            <div class="picdesc">
                                <div class="username">{{ myform.email }}</div>
                                <!-- <div class="userpaper">2 会议 | 5 论文 | 3 录用</div> -->
                            </div>
                        </div>
                        <el-form :model="myform" label-width="120px" label-position="left" class="myform">
                            <el-form-item label="email" label-width="100px" style="width:620px">
                                <el-input v-model="myform.email" :disabled="true" />
                            </el-form-item>
                            <el-form-item label="phone" label-width="100px" style="width:620px">
                                <el-input v-model="myform.phone" :disabled="!isChange" />
                            </el-form-item>
                            <el-form-item label="firstname" label-width="100px" style="width:620px">
                                <el-input v-model="myform.firstname" :disabled="!isChange" />
                            </el-form-item>
                            <el-form-item label="lastname" label-width="100px" style="width:620px">
                                <el-input v-model="myform.lastname" :disabled="!isChange" />
                            </el-form-item>
                            <el-form-item label="country" label-width="100px" style="width:620px">
                                <el-select v-model="myform.country" placeholder="Please select a country"
                                    :disabled="!isChange">
                                    <el-option :value="item.label" :label="item.label" v-for="item in countryList"
                                        :key="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="affiliation" label-width="100px" style="width:620px">
                                <el-input v-model="myform.affiliation" :disabled="!isChange" />
                            </el-form-item>
                            <el-form-item label="webpage" label-width="100px" style="width:620px">
                                <el-input v-model="myform.webpage" :disabled="!isChange" />
                            </el-form-item>
                            <el-form-item label="passwd" label-width="100px" style="width:620px">
                                <el-input v-model="myform.passwd" :disabled="!isChange" />
                            </el-form-item>
                            <el-from-item>
                                <el-button type="primary" @click="onSubmit" style="width:170px;margin-top:40px" :disabled="!isChange">Modifying Information</el-button>
                            </el-from-item>
                        </el-form>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
    <!-- 隐藏层，用于效验密码 -->
    <el-dialog v-model="dialogFormVisible" title="Password security verification" width="30%">
        <el-form :model="form" style="margin-top: 15px">
            <el-form-item label="Original password" :label-width="140">
                <el-input v-model="oldpasswd" autocomplete="off" style="width:300px" placeholder="Please enter your original password" />
            </el-form-item>
            <el-form-item label="New password" :label-width="140">
                <el-input v-model="myform.passwd" autocomplete="off" style="width:300px" disabled />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="dialogFormVisible = false">Cancel</el-button>
                <el-button type="primary" @click="check">
                    Validation
                </el-button>
            </span>
        </template>
    </el-dialog>
</template>

<script setup>
import { ref, onMounted } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { useStore } from "vuex"
import request from "../../network/request"
import { ElMessage } from 'element-plus'
import { ElNotification } from 'element-plus'


const store = useStore()
const isChange = ref(false)
const oldpasswd = ref('')
const countryList = ref([])
const dialogFormVisible = ref(false)
const token = store.state.user.token

// 个人信息
const myform = ref({
    email: '',
    phone: '',
    firstname: '',
    lastname: '',
    country: '',
    affiliation: '',
    Webpage: '',
    passwd: '',
    pic: ''
})



// 头像上传
const handleAvatarSuccess = (response, uploadFile) => {
    ElMessage({message: 'avatar uploaded successfully',type: 'success'})
    myform.value.pic = response.data
    store.commit("setUserPic", myform.value.pic)
}

// 效验新旧密码
const check = () => {
    request.post("/user/login", {
        email: myform.value.email,
        passwd: oldpasswd.value,
    }, {
        headers: {
            'content-type': 'multipart/form-data'
        }
    }).then((res) => {
        if (res.code == 200) {
            request.post("/user/update", myform.value).then((res) => {
                myform.value = res.data
                ElMessage({
                    message: 'validation successful, information updated',
                    type: 'success',
                })
                isChange.value = false
                dialogFormVisible.value = false
            })
        }
        else {
            ElMessage({
                message: 'verification failed, the original password is incorrect',
                type: 'warning',
            })
        }
    })
}

// 个人信息更新
const onSubmit = () => {
    if (!myform.value.passwd) {
        request.post("/user/update", myform.value).then((res) => {
            myform.value = res.data
            ElMessage({
                message: 'user information updated successfully',
                type: 'success',
            })
            isChange.value = false
        })
    }
    // 涉及密码修改需要先效验身份
    else {
        ElNotification({
            title: 'Password security verification',
            message: 'require original password verification',
            type: 'warning',
            position: 'top-left',
        })
        dialogFormVisible.value = true
    }

}

onMounted(() => {
    // 获取城市信息
    request.get("/common/country").then((res) => {
        countryList.value = res.data
    })
    // 获取用户信息
    request.post("/user/info", { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        myform.value = res.data
    })
})

</script>


<style lang="scss">
.my-container {
    .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
    }

    .picbox {
        display: flex;
        align-items: center;
        margin-bottom: 40px;
        justify-content: center;

        .picdesc {
            display: flex;
            flex-direction: column;
            align-items: center;

            margin-left: 15px;

            .username {
                font-size: 15px;
                font-weight: 700;
                color: rgb(24, 24, 24);
                // margin-bottom: 12px;
                text-align: center;
            }

            .userpaper {
                font-size: 13px;
                color: rgba(71, 143, 206, 0.725);
            }
        }
    }

    .myform {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .mypic:hover {
        opacity: .8;
    }
}
</style>